<template>
    <section class="blockElement space connectingBroker vh-100">
        <Header />
        <div class="container calcPadding" v-if="connectedBroker.length">
            <div class="row justify-content-center align-items-center heightCalc">
                <router-link class="d-flex align-items-center backBtn medium" :to="{name : 'broker_account'}" v-if="!store.acoountconnecting && !store.linkBrokerStatus">
                    <vue-feather class="me-2" type="arrow-left" size="15"></vue-feather> {{$t('financial_detail.text1')}}
                </router-link>
                <div class="col-12 col-lg-9 text-center">
                     <div class="connectingAccount d-flex justify-content-center align-items-center mb-4">
                        <span class="rounded-circle one"><img :src="'https://zulutrade.com/'+connectedBroker[0].logoUrl" :alt="$t('connect_account.text13')" :title="$t('connect_account.text14')" /></span>
                        <span class="mx-4 mx-md-5 customLoader" v-if="store.acoountconnecting && !store.linkBrokerStatus">
                            <span class="circle circle-1"></span>
                            <span class="circle circle-2"></span>
                            <span class="circle circle-3"></span>
                            <span class="circle circle-4"></span>
                            <span class="circle circle-5"></span>
                        </span>
                        <span class="mx-4 customLoader"  v-else-if="!store.acoountconnecting && store.linkBrokerStatus">
                            <img :src="`${static_vars.imagePath}/assets/images/success-connected.png`" width="140" class="d-block mx-auto" :alt="$t('connect_account.text15')" style="width: 60px; height: auto; ">
                        </span>
                        <span class="mx-4 customLoader"  v-else-if="!store.acoountconnecting && !store.linkBrokerStatus">
                            <img :src="`${static_vars.imagePath}/assets/images/not-connected.png`" width="140" class="d-block mx-auto" :alt="$t('connect_account.text15')" style="width: 60px; height: auto; ">
                        </span>
                        <span class="rounded-circle two"><img :src="`${static_vars.imagePath}/assets/images/zulu.svg`" :alt="$t('connect_account.text12')" :title="$t('connect_account.text12')" /></span>
                     </div>
                     <div class="content">
                        <h6 class="f-18 mb-4" v-if="store.acoountconnecting && !store.linkBrokerStatus">{{$t('connect_account.text1')}}</h6>
                        <h3 class="mb-4" v-else-if="!store.acoountconnecting && store.linkBrokerStatus">{{$t('connect_account.text2')}} <span class="green">{{$t('connect_account.text3')}} </span> {{$t('connect_account.text4')}}</h3>
                         <h6 class="mb-5 text-danger" v-else-if="!store.acoountconnecting && !store.linkBrokerStatus">
                            {{ errorMessage() }}
                        </h6>
                        <h6 class="f-18 mb-4 pb-md-3" v-if="!(!store.acoountconnecting && !store.linkBrokerStatus)">{{$t('connect_account.text5')}}</h6>
                        <div class="existingBroker d-flex align-items-center justify-content-center my-4 pb-md-5" v-if="!(!store.acoountconnecting && !store.linkBrokerStatus)">
                            <a href="javascript:void(0);" @click="testAlreadyDone()" class="grd_btn semibold me-3">{{$t('connect_account.text6')}}</a>
                            <router-link to="/become-leader" class="grd_btn semibold border-btn" :class="[{'disabled' : !store.linkBrokerStatus}]"> {{$t('connect_account.text7')}} </router-link>
                            <!-- :class="[{'disabled' : !store.linkBrokerStatus}]" -->
                        </div>
                     </div>
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <div class="superlightgray h-100 text-start">
                                <h6 class="semibold">{{$t('connect_account.text8')}}</h6>
                                <p class="f-14 mb-0">{{$t('connect_account.text9')}}</p>
                            </div>
                        </div>
                        <div class="col-md-6 col-12">
                            <div class="superlightgray h-100 text-start">
                                <h6 class="semibold">{{$t('connect_account.text10')}}</h6>
                                <p class="f-14 mb-0">{{$t('connect_account.text11')}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <stepFooter />
    </section>
</template>
<script>
    import { useMainStore } from "@/store";
    import stepFooter from "../../components/shared/step_footer";
    export default {
        setup() {
            const store = useMainStore();
            return { store };
        },
        data(){
            return{
                connectedBroker : {}
            }
        },
        components: { 
            stepFooter 
        },
        methods:{
            testAlreadyDone(){
                if(this.store.userAccoutDetail.requiredActions && this.store.userAccoutDetail.requiredActions.length){
                    this.$router.replace({path : '/sutaibility'})
                }else{
                    let path = `${this.static_vars.domainURL}leaders`
                    window.location.replace(path)
                }
            },
            errorMessage(){
                if(this.store.socketError?.systemErrorMessage == 'INVALID_BASE_CURRENCY'){
                    return this.$t('connect_account.INVALID_BASE_CURRENCY')
                } else {
                    return this.$t('connect_account.INVALID_USERNAME_OR_PASSWORD')
                }
            }
        },
        created(){
            this.store.getUserAccountsList({},false)
            this.store.$patch({'acoountconnecting' : true})
            this.store.$patch({'linkBrokerStatus' : false})
            if(this.store.linkBrokerID && this.store.brokerPlatformList.length){
                //let brokers = [];
                this.store.brokerPlatformList.forEach(i =>{
                    if(i.brokers && i.brokers.length){
                        // if(!brokers.length){
                        //     brokers = i.brokers
                        // }else{
                        //     brokers.concat(i.brokers)
                        // }
                        let data = i.brokers.filter(i => parseInt(i.id) == parseInt(this.store.linkBrokerID));
                        if(data.length){
                            this.connectedBroker = data
                        }
                    }
                })
                // console.log('==>',brokers)
                // if(brokers.length){
                //     let data = brokers.filter(i => parseInt(i.id) == parseInt(this.store.linkBrokerID));
                //     if(data.length){
                //         this.connectedBroker = data
                //     }else{
                //         this.connectedBroker = {}
                //     }
                // }
            }
        }
    };
</script>